import api from './client';

export interface TranscriptEntry {
  speaker: 'agent' | 'human';
  text: string;
  timestamp: string;
  sequence?: number;
  confidence?: number;
}

export interface ActiveCall {
  callSid: string;
  sessionId: string;
  agentId: string;
  agentName: string;
  phone: string;
  duration: number; // seconds
  status: string;
  transcript: TranscriptEntry[];
}

export interface LiveStats {
  activeCalls: number;
  callsInQueue: number;
  agentsIdle: number;
  callsThisHour: number;
}

export const monitorApi = {
  getActiveCalls: () =>
    api.get<{ data: ActiveCall[] }>('/api/v1/monitor/active-calls').then((r) => r.data.data),

  getTranscript: (callSid: string) =>
    api
      .get<{ data: TranscriptEntry[] }>(`/api/v1/monitor/calls/${callSid}/transcript`)
      .then((r) => r.data.data),

  whisper: (callSid: string, text: string) =>
    api
      .post<{ ok: boolean; message: string }>(`/api/v1/monitor/calls/${callSid}/whisper`, { text })
      .then((r) => r.data),

  endCall: (callSid: string) =>
    api
      .post<{ ok: boolean; message: string }>(`/api/v1/monitor/calls/${callSid}/end`)
      .then((r) => r.data),

  getLiveStats: () =>
    api.get<{ data: LiveStats }>('/api/v1/monitor/stats/live').then((r) => r.data.data),
};
